export default {
    close: 'Close',
    update: 'Update and close',
    save: 'Save and close',
    comment: 'Comment',
    amount: 'Amount',
}
